// src/data.js

export const PAGES = [
  {
    code: 'india',
    name: 'India.shades',
    username: 'india.shades',
    link: 'https://www.instagram.com/india.shades/',
    facebook: 'https://www.facebook.com/profile.php?id=61584051830695',
    blurb: 'National page for everything India, from parliament to pavements.',
    coverage: 'Entire India (National scope)',
    includes: 'All states and union territories'
  },
  {
    code: 'north',
    name: 'North.shades',
    username: 'north.shades',
    link: 'https://www.instagram.com/north.shades/',
    facebook: 'https://www.facebook.com/profile.php?id=61583935288634',
    blurb: 'Power corridors, borders and wheat belt of North India.',
    coverage: 'Delhi, Haryana, Punjab, Uttar Pradesh, Chandigarh',
    includes: 'Delhi (NCT), Haryana, Punjab, Uttar Pradesh, Chandigarh (UT)'
  },
  {
    code: 'south',
    name: 'South.shades',
    username: 'south.shades',
    link: 'https://www.instagram.com/south.shades/',
    facebook: 'https://www.facebook.com/profile.php?id=61583874361006',
    blurb: 'Tech, cinema and welfare politics from the southern states.',
    coverage: 'Southern India',
    includes: 'Tamil Nadu, Kerala, Karnataka, Andhra Pradesh, Telangana, Puducherry (UT)'
  },
  {
    code: 'east',
    name: 'East.shades',
    username: 'east.shades',
    link: 'https://www.instagram.com/east.shades/',
    facebook: 'https://www.facebook.com/profile.php?id=61583797624722',
    blurb: 'Rivers, coal and politics from the eastern belt.',
    coverage: 'Eastern India',
    includes: 'Bihar, Jharkhand, Odisha, West Bengal'
  },
  {
    code: 'west',
    name: 'West.shades',
    username: 'west.shades',
    link: 'https://www.instagram.com/west.shades/',
    facebook: 'https://www.facebook.com/profile.php?id=61583867581380',
    blurb: 'Ports, finance and deserts from the western coast and plains.',
    coverage: 'Western India',
    includes: 'Gujarat, Rajasthan, Maharashtra, Goa'
  },
  {
    code: 'himalayan',
    name: 'Himalayan.shades',
    username: 'himalayan.shades',
    link: 'https://www.instagram.com/himalayan.shades/',
    facebook: 'https://www.facebook.com/profile.php?id=61583660347664',
    blurb: 'Mountain politics, tourism and border stories from the Himalayas.',
    coverage: 'Himalayan states and territories',
    includes: 'Jammu and Kashmir, Ladakh, Himachal Pradesh, Uttarakhand'
  },
  {
    code: 'heartland',
    name: 'Heartland.shades',
    username: 'heartland.shades',
    link: 'https://www.instagram.com/heartland.shades/',
    facebook: 'https://www.facebook.com/profile.php?id=61583931478610',
    blurb: 'Coal belt, farms and politics from the Indian heartland.',
    coverage: 'Central India',
    includes: 'Madhya Pradesh, Chhattisgarh'
  },
  {
    code: 'northeast',
    name: 'Northeast.shades',
    username: 'northeast.shades',
    link: 'https://www.instagram.com/northeast.shades/',
    facebook: 'https://www.facebook.com/profile.php?id=61583476245235',
    blurb: 'Hill states, borders and culture from the North East.',
    coverage: 'North Eastern region',
    includes: 'Assam, Arunachal Pradesh, Manipur, Meghalaya, Mizoram, Nagaland, Tripura, Sikkim'
  },
  {
    code: 'Unfiltered',
    name: 'Unfiltered.shades',
    username: 'Unfiltered.shades',
    link: 'https://www.instagram.com/Unfiltered.shades/',
    facebook: 'https://www.facebook.com/profile.php?id=61583882160751',
    blurb: 'Unfiltered India',
    coverage: 'Entire India',
    includes: 'Every Corner'
  },
  {
    code: 'Funny',
    name: 'Funny.shades',
    username: 'Funny.shades',
    link: 'https://www.instagram.com/Funny.shades/',
    facebook: 'https://www.facebook.com/profile.php?id=61583831643305',
    blurb: 'Content that will make you Laugh',
    coverage: 'Funny India',
    includes: 'Every Corner of India'
  },
  {
    code: 'usa',
    name: 'USA.shades',
    username: 'usa.shades',
    link: 'https://www.instagram.com/usa.shades/',
    facebook: 'https://www.facebook.com/profile.php?id=61583982446131',
    blurb: 'US politics, markets and culture in sharp focus.',
    coverage: 'United States of America',
    includes: 'All states and territories'
  },
  {
    code: 'worldwide',
    name: 'Worldwide.shades',
    username: 'worldwide.shades',
    link: 'https://www.instagram.com/worldwide.shades/',
    facebook: 'https://www.facebook.com/profile.php?id=61584027834037',
    blurb: 'Global stories, conflicts and markets in one stream.',
    coverage: 'World',
    includes: 'Cross country coverage'
  },
  {
    code: 'network',
    name: 'Network.shades',
    username: 'network.shades',
    link: 'https://www.instagram.com/network.shades/',
    facebook: '',
    blurb: 'Central hub for the full Shades Network and announcements.',
    coverage: 'Admin and ecosystem',
    includes: 'All Shades pages'
  }
]

// shared YouTube channel for the network
export const YOUTUBE_CHANNEL = 'https://www.youtube.com/@Shades.Network'
